import { observer } from 'mobx-react-lite'
import { type JobDetailsViewModel } from '@/features/jobs/details/JobDetailsViewModel'
import { ContentLoading } from '@/components/ContentLoading'
import { ContentError } from '@/components/ContentError'
import { MobileJobProgressionSummary } from '@/features/jobs/details/components/MobileJob'

export interface MobileJobProgressionSummaryContainerProps {
  vm: JobDetailsViewModel
}

export const MobileJobProgressionSummaryContainer = observer(
  function MobileJobProgressionSummaryContainer({
    vm,
  }: MobileJobProgressionSummaryContainerProps) {
    const jobProgressionVm = vm.jobProgressionVm
    if (!vm.isProgressionFlowEnabled) {
      return null
    }

    const jobIsCompleted = vm.job.completed
    const currentStepInfo = jobProgressionVm.currentStepInfo

    const renderSummary = () => (
      <MobileJobProgressionSummary
        title={jobIsCompleted ? 'Job completed' : currentStepInfo?.title}
        completionStatus={jobProgressionVm.completionStatus}
        pendingCompletionStatus={jobProgressionVm.pendingCompletionStatus}
      />
    )

    return jobProgressionVm.fetch.match({
      pending: () =>
        jobProgressionVm.isRevalidating ? (
          renderSummary()
        ) : (
          <ContentLoading size="section" />
        ),
      rejected: (err) => (
        <ContentError
          size="section"
          title="An error occurred while loading the job progression."
          error={err}
        />
      ),
      resolved: renderSummary,
    })
  },
)
